<template>
  <div>
    {{ dateUtil(new Date(item.nextExecution), false, "FEHLER") }}
  </div>
</template>
<script>
import { dateUtil } from "../../api/api";
export default {
  props: ["item"],
  methods: {
    dateUtil,
  },
};
</script>
